import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import {
  AccountService,
  AgentSignupData,
  Country,
  DefaultResponse,
  LoadingService,
  MessageService
} from '@core';

@Component({
  selector: 'app-signup',
  templateUrl: 'signup.page.html',
  styleUrls: ['signup.page.scss']
})
export class AccessSignupPage {

  showErrors = false;
  errors = null;

  form: FormGroup = new FormGroup({
    firstName: new FormControl(),
    lastName: new FormControl(),
    email: new FormControl(),
    username: new FormControl(),
    password: new FormControl(),
    confirmPassword: new FormControl(),
    recaptcha: new FormControl(),
  });

  constructor(
    private router: Router,
    private accountService: AccountService,
    private loadingService: LoadingService,
    private messageService: MessageService
  ) {}

  submit() {
    const { form, loadingService, messageService, accountService, router } = this;
    const data = form.value as AgentSignupData;

    if (form.invalid) return;

    loadingService.start();

    accountService.signup(data).subscribe({
      next: resp => {
        messageService.alert('', resp.message, 'success').then(() => {
          router.navigate(['/']);
        });
      },

      error: messageService.handle,

      complete: () => {
        loadingService.stop();
      }
    });
  }

}
